import React from 'react';
import { Modal, Button, Tag } from 'antd';

export default function UserViewModal({
  open,
  onCancel,
  user,
  roleOptions,
  formatDateTime,
  balance,
  onWithdrawPoints,
}) {
  if (!user) return null;

  return (
    <Modal
      title="View user"
      open={!!open}
      onCancel={onCancel}
      footer={[
        ...(onWithdrawPoints
          ? [
              <Button
                key="withdraw"
                type="primary"
                onClick={() => {
                  onCancel();
                  onWithdrawPoints();
                }}
                className="app-btn-primary"
              >
                Withdraw points
              </Button>,
            ]
          : []),
        <Button key="close" onClick={onCancel} className="app-btn-cancel">
          Close
        </Button>,
      ]}
      destroyOnClose
      width={420}
      className="user-list-modal"
    >
      <div className="user-list-view">
        <div className="user-list-view-header">
          <div className="user-list-view-avatar">
            {(user.name || user.email || '?').charAt(0).toUpperCase()}
          </div>
          <div className="user-list-view-title">{user.name || '—'}</div>
          <div className="user-list-view-subtitle">{user.email}</div>
          <Tag
            className={
              user.status !== false
                ? 'user-list-tag-status-active user-list-view-status'
                : 'user-list-tag-status-inactive user-list-view-status'
            }
          >
            {user.status !== false ? 'Active' : 'Inactive'}
          </Tag>
        </div>
        <div className="user-list-view-section">
          <div className="user-list-view-section-title">Roles</div>
          <div className="user-list-view-row">
            <span className="user-list-view-value">
              {Array.isArray(user.roles) && user.roles.length > 0 ? (
                user.roles.map((r) => (
                  <Tag key={r} className="user-list-tag-role">
                    {roleOptions?.find((o) => o.value === r)?.label ?? r}
                  </Tag>
                ))
              ) : (
                '—'
              )}
            </span>
          </div>
        </div>
        {balance !== undefined && balance !== null && (
          <div className="user-list-view-section">
            <div className="user-list-view-section-title">Points</div>
            <div className="user-list-view-row">
              <span className="user-list-view-label">Balance</span>
              <span className="user-list-view-value">{balance}</span>
            </div>
          </div>
        )}
        <div className="user-list-view-section">
          <div className="user-list-view-section-title">Activity</div>
          <div className="user-list-view-row">
            <span className="user-list-view-label">Created</span>
            <span className="user-list-view-value">
              {formatDateTime ? formatDateTime(user.created_at) : '—'}
            </span>
          </div>
          <div className="user-list-view-row">
            <span className="user-list-view-label">Created by</span>
            <span className="user-list-view-value">
              {user.created_by?.name || user.created_by?.email || '—'}
            </span>
          </div>
          <div className="user-list-view-row">
            <span className="user-list-view-label">Updated</span>
            <span className="user-list-view-value">
              {formatDateTime ? formatDateTime(user.updated_at) : '—'}
            </span>
          </div>
          <div className="user-list-view-row">
            <span className="user-list-view-label">Updated by</span>
            <span className="user-list-view-value">
              {user.updated_by?.name || user.updated_by?.email || '—'}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}
